module.exports = __webpack_public_path__ + "static/media/03_plantilla_combo_rectangular_marco_comida_10.f11c9df2.png";